const UserIds = {
    simulated: 2147483647
};
export default UserIds;
